export const FIND_TRANSLATION = 'OVID/FIND_TRANSLATION/FETCH'
export const FIND_TRANSLATION_SUCCESS = 'OVID/FIND_TRANSLATION/SUCCESS'
export const FIND_TRANSLATION_FAILED = 'OVID/FIND_TRANSLATION/FAILED'
export const FIND_TRANSLATION_NOT_FOUND = 'OVID/FIND_TRANSLATION/NOT_FOUND'
export const GET_TRANSLATION_TOKEN_INIT = 'OVID/GET_TRANSLATION_TOKEN_INIT'
export const GET_TRANSLATION_TOKEN = 'OVID/GET_TRANSLATION_TOKEN'
export const GOT_TRANSLATION_TOKEN = 'OVID/GOT_TRANSLATION_TOKEN'
export const GET_TRANSLATION_TOKEN_FAILED = 'OVID/GET_TRANSLATION_TOKEN_FAILED'
